import React from 'react';
import { Button } from 'react-bootstrap';
import styles from './EmptyState.module.scss';

export default function EmptyState({ icon: Icon, title, description, actionLabel, onAction }) {
  return (
    <div className={styles.wrap}>
      {Icon && (
        <div className={styles.icon}>
          <Icon size={48} strokeWidth={1.25} />
        </div>
      )}
      <div className={styles.title}>{title}</div>
      {description && <p className={styles.desc}>{description}</p>}
      {actionLabel && onAction && (
        <Button variant="primary" onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
